/**
 * clientapi
 * Facere Facility Client API
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ApiAuthRequest } from '../model/apiAuthRequest';
import { ApiAuthResponse } from '../model/apiAuthResponse';
import { ApiSetExhibitAttributesRequest } from '../model/apiSetExhibitAttributesRequest';
import { ApiSetExhibitAttributesResponse } from '../model/apiSetExhibitAttributesResponse';
import { ApiSetExhibitDetailAttributesRequest } from '../model/apiSetExhibitDetailAttributesRequest';
import { ApiSetExhibitDetailAttributesResponse } from '../model/apiSetExhibitDetailAttributesResponse';
import { ApiSetExhibitsRequest } from '../model/apiSetExhibitsRequest';
import { ApiSetExhibitsResponse } from '../model/apiSetExhibitsResponse';
import { ApiSetExhibitDetailsRequest } from '../model/apiSetExhibitDetailsRequest';
import { ApiSetExhibitDetailsResponse } from '../model/apiSetExhibitDetailsResponse';
import { ApiSetFacilitiesRequest } from '../model/apiSetFacilitiesRequest';
import { ApiSetFacilitiesResponse } from '../model/apiSetFacilitiesResponse';
import { ApiSetFacilityAttributesRequest } from '../model/apiSetFacilityAttributesRequest';
import { ApiSetFacilityAttributesResponse } from '../model/apiSetFacilityAttributesResponse';
import { ApiSetLanguagesRequest } from '../model/apiSetLanguagesRequest';
import { ApiSetLanguagesResponse } from '../model/apiSetLanguagesResponse';
import { ApiSetProjectsRequest } from '../model/apiSetProjectsRequest';
import { ApiSetProjectsResponse } from '../model/apiSetProjectsResponse';
import { ApiSetReservationFacilitiesRequest } from '../model/apiSetReservationFacilitiesRequest';
import { ApiSetReservationFacilitiesResponse } from '../model/apiSetReservationFacilitiesResponse';
import { ApiSetReservationFacilitySpecialsRequest } from '../model/apiSetReservationFacilitySpecialsRequest';
import { ApiSetReservationFacilitySpecialsResponse } from '../model/apiSetReservationFacilitySpecialsResponse';
import { ApiSetReservationQuestionsRequest } from '../model/apiSetReservationQuestionsRequest';
import { ApiSetReservationQuestionsResponse } from '../model/apiSetReservationQuestionsResponse';
import { ApiSetReservationsRequest } from '../model/apiSetReservationsRequest';
import { ApiSetReservationsResponse } from '../model/apiSetReservationsResponse';
import { ApiSetReservationFacilityAttributesRequest } from '../model/apiSetReservationFacilityAttributesRequest';
import { ApiSetReservationFacilityAttributesResponse } from '../model/apiSetReservationFacilityAttributesResponse';
import { ApiSetUploadedFilesRequest } from '../model/apiSetUploadedFilesRequest';
import { ApiSetUploadedFilesResponse } from '../model/apiSetUploadedFilesResponse';
import { ApiSetUploadedFilesAttributesRequest } from '../model/apiSetUploadedFilesAttributesRequest';
import { ApiSetUploadedFilesAttributesResponse } from '../model/apiSetUploadedFilesAttributesResponse';
import { ApiSetUsersRequest } from '../model/apiSetUsersRequest';
import { ApiSetUsersResponse } from '../model/apiSetUsersResponse';
import { ApiSetFacilityUsersRequest } from '../model/apiSetFacilityUsersRequest';
import { ApiSetFacilityUsersResponse } from '../model/apiSetFacilityUsersResponse';
import { ApiSetFloorsRequest } from '../model/apiSetFloorsRequest';
import { ApiSetFloorsResponse } from '../model/apiSetFloorsResponse';
import { ApiSetHallsRequest } from '../model/apiSetHallsRequest';
import { ApiSetHallsResponse } from '../model/apiSetHallsResponse';
import { ApiSetGeneralTextsRequest } from '../model/apiSetGeneralTextsRequest';
import { ApiSetGeneralTextsResponse } from '../model/apiSetGeneralTextsResponse';
import { ApiReflectDataRequest } from '../model/apiReflectDataRequest';
import { ApiReflectDataResponse } from '../model/apiReflectDataResponse';
import { ApiSetReflectDataScheduleRequest } from '../model/apiSetReflectDataScheduleRequest';
import { ApiSetReflectDataScheduleResponse } from '../model/apiSetReflectDataScheduleResponse';
import { ApiSetNoticesRequest } from '../model/apiSetNoticesRequest';
import { ApiSetNoticesResponse } from '../model/apiSetNoticesResponse';
import { ApiSetBoardThreadRequest } from '../model/apiSetBoardThreadRequest';
import { ApiSetBoardThreadResponse } from '../model/apiSetBoardThreadResponse';
import { ApiSetBoardCommentRequest } from '../model/apiSetBoardCommentRequest';
import { ApiSetBoardCommentResponse } from '../model/apiSetBoardCommentResponse';
import { ApiSetQuestionsRequest } from '../model/apiSetQuestionsRequest';
import { ApiSetQuestionsResponse } from '../model/apiSetQuestionsResponse';
import { ApiSetQuestSetRequest } from '../model/apiSetQuestSetRequest';
import { ApiSetQuestSetResponse } from '../model/apiSetQuestSetResponse';
import { ApiCreateEnqueteDownloadFilesRequest } from '../model/apiCreateEnqueteDownloadFilesRequest';
import { ApiCreateEnqueteDownloadFilesResponse } from '../model/apiCreateEnqueteDownloadFilesResponse';
import { ApiCreateReservationDownloadFilesRequest } from '../model/apiCreateReservationDownloadFilesRequest';
import { ApiCreateReservationDownloadFilesResponse } from '../model/apiCreateReservationDownloadFilesResponse';
import { ApiSetSheltersRequest } from '../model/apiSetSheltersRequest';
import { ApiSetSheltersResponse } from '../model/apiSetSheltersResponse';
import { ApiSetReservationsStatusRequest } from '../model/apiSetReservationsStatusRequest';
import { ApiSetReservationsStatusResponse } from '../model/apiSetReservationsStatusResponse';
import { ApiSetLotteriesRequest } from '../model/apiSetLotteriesRequest';
import { ApiSetLotteriesResponse } from '../model/apiSetLotteriesResponse';
import { ApiSetEntranceExitUsersRequest } from '../model/apiSetEntranceExitUsersRequest';
import { ApiSetEntranceExitUsersResponse } from '../model/apiSetEntranceExitUsersResponse';
import { ApiSetEntranceExitQuestionsRequest } from '../model/apiSetEntranceExitQuestionsRequest';
import { ApiSetEntranceExitQuestionsResponse } from '../model/apiSetEntranceExitQuestionsResponse';
import { ApiSetEntranceExitEventsRequest } from '../model/apiSetEntranceExitEventsRequest';
import { ApiSetEntranceExitEventsResponse } from '../model/apiSetEntranceExitEventsResponse';
import { ApiSetEntranceExitEntriesRequest } from '../model/apiSetEntranceExitEntriesRequest';
import { ApiSetEntranceExitEntriesResponse } from '../model/apiSetEntranceExitEntriesResponse';
import { ApiSetEntranceExitExhibitTransitDownloadFilesRequest } from '../model/apiSetEntranceExitExhibitTransitDownloadFilesRequest';
import { ApiSetEntranceExitExhibitTransitDownloadFilesResponse } from '../model/apiSetEntranceExitExhibitTransitDownloadFilesResponse';
import { ApiSetSplatsRequest } from '../model/apiSetSplatsRequest';
import { ApiSetSplatsResponse } from '../model/apiSetSplatsResponse';
import { ApiGetSplatsKeyDevicesRequest } from '../model/apiGetSplatsKeyDevicesRequest';
import { ApiGetSplatsKeyDevicesResponse } from '../model/apiGetSplatsKeyDevicesResponse';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class DefaultService {

    protected basePath = 'https://asia-northeast1-facere-facility-dev.cloudfunctions.net';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 認証
     * auth v2
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public clientApiAuth(body?: ApiAuthRequest, observe?: 'body', reportProgress?: boolean): Observable<ApiAuthResponse>;
    public clientApiAuth(body?: ApiAuthRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApiAuthResponse>>;
    public clientApiAuth(body?: ApiAuthRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApiAuthResponse>>;
    public clientApiAuth(body?: ApiAuthRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ApiAuthResponse>(`${this.basePath}/authv2`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }




    /**
     * ユーザー情報
     * setUsers v2
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public clientApiSetUsers(body?: ApiSetUsersRequest, observe?: 'body', reportProgress?: boolean): Observable<ApiSetUsersResponse>;
    public clientApiSetUsers(body?: ApiSetUsersRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApiSetUsersResponse>>;
    public clientApiSetUsers(body?: ApiSetUsersRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApiSetUsersResponse>>;
    public clientApiSetUsers(body?: ApiSetUsersRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ApiSetUsersResponse>(`${this.basePath}/setUsersv2`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 汎用テキスト
     * setGeneralTexts v2
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public clientApiSetGeneralTexts(body?: ApiSetGeneralTextsRequest, observe?: 'body', reportProgress?: boolean): Observable<ApiSetGeneralTextsResponse>;
    public clientApiSetGeneralTexts(body?: ApiSetGeneralTextsRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApiSetGeneralTextsResponse>>;
    public clientApiSetGeneralTexts(body?: ApiSetGeneralTextsRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApiSetGeneralTextsResponse>>;
    public clientApiSetGeneralTexts(body?: ApiSetGeneralTextsRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ApiSetGeneralTextsResponse>(`${this.basePath}/setGeneralTextsv2`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 言語情報
     * setLanguages v2
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public clientApiSetLanguages(body?: ApiSetLanguagesRequest, observe?: 'body', reportProgress?: boolean): Observable<ApiSetLanguagesResponse>;
    public clientApiSetLanguages(body?: ApiSetLanguagesRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApiSetLanguagesResponse>>;
    public clientApiSetLanguages(body?: ApiSetLanguagesRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApiSetLanguagesResponse>>;
    public clientApiSetLanguages(body?: ApiSetLanguagesRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ApiSetLanguagesResponse>(`${this.basePath}/setLanguagesv2`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 通知情報
     * setNotices v2
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public clientApiSetNotices(body?: ApiSetNoticesRequest, observe?: 'body', reportProgress?: boolean): Observable<ApiSetNoticesResponse>;
    public clientApiSetNotices(body?: ApiSetNoticesRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApiSetNoticesResponse>>;
    public clientApiSetNotices(body?: ApiSetNoticesRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApiSetNoticesResponse>>;
    public clientApiSetNotices(body?: ApiSetNoticesRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ApiSetNoticesResponse>(`${this.basePath}/setNoticesv2`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 掲示板(スレッド)
     * setBoardThread v2
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public clientApiSetBoardThread(body?: ApiSetBoardThreadRequest, observe?: 'body', reportProgress?: boolean): Observable<ApiSetBoardThreadResponse>;
    public clientApiSetBoardThread(body?: ApiSetBoardThreadRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApiSetBoardThreadResponse>>;
    public clientApiSetBoardThread(body?: ApiSetBoardThreadRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApiSetBoardThreadResponse>>;
    public clientApiSetBoardThread(body?: ApiSetBoardThreadRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ApiSetBoardThreadResponse>(`${this.basePath}/setBoardThreadv2`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 掲示板(コメント)
     * setBoardComment v2
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public clientApiSetBoardComment(body?: ApiSetBoardCommentRequest, observe?: 'body', reportProgress?: boolean): Observable<ApiSetBoardCommentResponse>;
    public clientApiSetBoardComment(body?: ApiSetBoardCommentRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApiSetBoardCommentResponse>>;
    public clientApiSetBoardComment(body?: ApiSetBoardCommentRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApiSetBoardCommentResponse>>;
    public clientApiSetBoardComment(body?: ApiSetBoardCommentRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ApiSetBoardCommentResponse>(`${this.basePath}/setBoardCommentv2`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }




    /**
     * プロジェクト情報
     * setProjects v2
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public clientApiSetProjects(body?: ApiSetProjectsRequest, observe?: 'body', reportProgress?: boolean): Observable<ApiSetProjectsResponse>;
    public clientApiSetProjects(body?: ApiSetProjectsRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApiSetProjectsResponse>>;
    public clientApiSetProjects(body?: ApiSetProjectsRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApiSetProjectsResponse>>;
    public clientApiSetProjects(body?: ApiSetProjectsRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ApiSetProjectsResponse>(`${this.basePath}/setProjectsv2`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * アップロードファイル
     * setUploadedFiles v2
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public clientApiSetUploadedFiles(body?: ApiSetUploadedFilesRequest, observe?: 'body', reportProgress?: boolean): Observable<ApiSetUploadedFilesResponse>;
    public clientApiSetUploadedFiles(body?: ApiSetUploadedFilesRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApiSetUploadedFilesResponse>>;
    public clientApiSetUploadedFiles(body?: ApiSetUploadedFilesRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApiSetUploadedFilesResponse>>;
    public clientApiSetUploadedFiles(body?: ApiSetUploadedFilesRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ApiSetUploadedFilesResponse>(`${this.basePath}/setUploadedFilesv2`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * アップロードファイル属性情報
     * setUploadedFilesAttributes v2
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public clientApiSetUploadedFilesAttributes(body?: ApiSetUploadedFilesAttributesRequest, observe?: 'body', reportProgress?: boolean): Observable<ApiSetUploadedFilesAttributesResponse>;
    public clientApiSetUploadedFilesAttributes(body?: ApiSetUploadedFilesAttributesRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApiSetUploadedFilesAttributesResponse>>;
    public clientApiSetUploadedFilesAttributes(body?: ApiSetUploadedFilesAttributesRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApiSetUploadedFilesAttributesResponse>>;
    public clientApiSetUploadedFilesAttributes(body?: ApiSetUploadedFilesAttributesRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ApiSetUploadedFilesAttributesResponse>(`${this.basePath}/setUploadedFilesAttributesv2`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * SPLATS情報
     * setSplats v2
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public clientApiSetSplats(body?: ApiSetSplatsRequest, observe?: 'body', reportProgress?: boolean): Observable<ApiSetSplatsResponse>;
    public clientApiSetSplats(body?: ApiSetSplatsRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApiSetSplatsResponse>>;
    public clientApiSetSplats(body?: ApiSetSplatsRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApiSetSplatsResponse>>;
    public clientApiSetSplats(body?: ApiSetSplatsRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ApiSetSplatsResponse>(`${this.basePath}/setSplatsv2`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }




    /**
     * 施設情報
     * setFacilities v2
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public clientApiSetFacilities(body?: ApiSetFacilitiesRequest, observe?: 'body', reportProgress?: boolean): Observable<ApiSetFacilitiesResponse>;
    public clientApiSetFacilities(body?: ApiSetFacilitiesRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApiSetFacilitiesResponse>>;
    public clientApiSetFacilities(body?: ApiSetFacilitiesRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApiSetFacilitiesResponse>>;
    public clientApiSetFacilities(body?: ApiSetFacilitiesRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ApiSetFacilitiesResponse>(`${this.basePath}/setFacilitiesv2`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * SPLATSキーデバイス取得
     * getSplatsKeyDevices v2
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public clientApiGetSplatsKeyDevices(body?: ApiGetSplatsKeyDevicesRequest, observe?: 'body', reportProgress?: boolean): Observable<ApiGetSplatsKeyDevicesResponse>;
    public clientApiGetSplatsKeyDevices(body?: ApiGetSplatsKeyDevicesRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApiGetSplatsKeyDevicesResponse>>;
    public clientApiGetSplatsKeyDevices(body?: ApiGetSplatsKeyDevicesRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApiGetSplatsKeyDevicesResponse>>;
    public clientApiGetSplatsKeyDevices(body?: ApiGetSplatsKeyDevicesRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ApiGetSplatsKeyDevicesResponse>(`${this.basePath}/getSplatsKeyDevicesv2`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }     

    /**
     * 本番反映（即時）
     * reflectData v2
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public clientApiReflectData(body?: ApiReflectDataRequest, observe?: 'body', reportProgress?: boolean): Observable<ApiReflectDataResponse>;
    public clientApiReflectData(body?: ApiReflectDataRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApiReflectDataResponse>>;
    public clientApiReflectData(body?: ApiReflectDataRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApiReflectDataResponse>>;
    public clientApiReflectData(body?: ApiReflectDataRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ApiReflectDataResponse>(`${this.basePath}/reflectDatav2`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 本番反映（予約）
     * setReflectDataSchedule v2
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
     public clientApiSetReflectDataSchedule(body?: ApiSetReflectDataScheduleRequest, observe?: 'body', reportProgress?: boolean): Observable<ApiSetReflectDataScheduleResponse>;
     public clientApiSetReflectDataSchedule(body?: ApiSetReflectDataScheduleRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApiSetReflectDataScheduleResponse>>;
     public clientApiSetReflectDataSchedule(body?: ApiSetReflectDataScheduleRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApiSetReflectDataScheduleResponse>>;
     public clientApiSetReflectDataSchedule(body?: ApiSetReflectDataScheduleRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


         let headers = this.defaultHeaders;

         // to determine the Accept header
         let httpHeaderAccepts: string[] = [
             'application/json'
         ];
         const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
         if (httpHeaderAcceptSelected != undefined) {
             headers = headers.set('Accept', httpHeaderAcceptSelected);
         }

         // to determine the Content-Type header
         const consumes: string[] = [
             'application/json'
         ];
         const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
         if (httpContentTypeSelected != undefined) {
             headers = headers.set('Content-Type', httpContentTypeSelected);
         }

         return this.httpClient.post<ApiSetReflectDataScheduleResponse>(`${this.basePath}/setReflectDataSchedulev2`,
             body,
             {
                 withCredentials: this.configuration.withCredentials,
                 headers: headers,
                 observe: observe,
                 reportProgress: reportProgress
             }
         );
     }

    /**
     * 建物・カテゴリ情報
     * setHalls v2
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public clientApiSetHalls(body?: ApiSetHallsRequest, observe?: 'body', reportProgress?: boolean): Observable<ApiSetHallsResponse>;
    public clientApiSetHalls(body?: ApiSetHallsRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApiSetHallsResponse>>;
    public clientApiSetHalls(body?: ApiSetHallsRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApiSetHallsResponse>>;
    public clientApiSetHalls(body?: ApiSetHallsRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ApiSetHallsResponse>(`${this.basePath}/setHallsv2`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * フロア・表示グループ情報
     * setFloors v2
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public clientApiSetFloors(body?: ApiSetFloorsRequest, observe?: 'body', reportProgress?: boolean): Observable<ApiSetFloorsResponse>;
    public clientApiSetFloors(body?: ApiSetFloorsRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApiSetFloorsResponse>>;
    public clientApiSetFloors(body?: ApiSetFloorsRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApiSetFloorsResponse>>;
    public clientApiSetFloors(body?: ApiSetFloorsRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ApiSetFloorsResponse>(`${this.basePath}/setFloorsv2`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 施設職員情報
     * setFacilityUsers v2
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public clientApiSetFacilityUsers(body?: ApiSetFacilityUsersRequest, observe?: 'body', reportProgress?: boolean): Observable<ApiSetFacilityUsersResponse>;
    public clientApiSetFacilityUsers(body?: ApiSetFacilityUsersRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApiSetFacilityUsersResponse>>;
    public clientApiSetFacilityUsers(body?: ApiSetFacilityUsersRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApiSetFacilityUsersResponse>>;
    public clientApiSetFacilityUsers(body?: ApiSetFacilityUsersRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ApiSetFacilityUsersResponse>(`${this.basePath}/setFacilityUsersv2`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }




    /**
     * 展示情報
     * setExhibits v2
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public clientApiSetExhibits(body?: ApiSetExhibitsRequest, observe?: 'body', reportProgress?: boolean): Observable<ApiSetExhibitsResponse>;
    public clientApiSetExhibits(body?: ApiSetExhibitsRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApiSetExhibitsResponse>>;
    public clientApiSetExhibits(body?: ApiSetExhibitsRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApiSetExhibitsResponse>>;
    public clientApiSetExhibits(body?: ApiSetExhibitsRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ApiSetExhibitsResponse>(`${this.basePath}/setExhibitsv2`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 展示詳細情報
     * setExhibitDetails v2
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public clientApiSetExhibitDetails(body?: ApiSetExhibitDetailsRequest, observe?: 'body', reportProgress?: boolean): Observable<ApiSetExhibitDetailsResponse>;
    public clientApiSetExhibitDetails(body?: ApiSetExhibitDetailsRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApiSetExhibitDetailsResponse>>;
    public clientApiSetExhibitDetails(body?: ApiSetExhibitDetailsRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApiSetExhibitDetailsResponse>>;
    public clientApiSetExhibitDetails(body?: ApiSetExhibitDetailsRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.post<ApiSetExhibitDetailsResponse>(`${this.basePath}/setExhibitDetailsv2`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }




    /**
     * 予約施設情報
     * setReservationFacilities v2
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public clientApiSetReservationFacilities(body?: ApiSetReservationFacilitiesRequest, observe?: 'body', reportProgress?: boolean): Observable<ApiSetReservationFacilitiesResponse>;
    public clientApiSetReservationFacilities(body?: ApiSetReservationFacilitiesRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApiSetReservationFacilitiesResponse>>;
    public clientApiSetReservationFacilities(body?: ApiSetReservationFacilitiesRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApiSetReservationFacilitiesResponse>>;
    public clientApiSetReservationFacilities(body?: ApiSetReservationFacilitiesRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ApiSetReservationFacilitiesResponse>(`${this.basePath}/setReservationFacilitiesv2`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 予約施設（特別営業日）情報
     * setReservationFacilitySpecials v2
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public clientApiSetReservationFacilitySpecials(body?: ApiSetReservationFacilitySpecialsRequest, observe?: 'body', reportProgress?: boolean): Observable<ApiSetReservationFacilitySpecialsResponse>;
    public clientApiSetReservationFacilitySpecials(body?: ApiSetReservationFacilitySpecialsRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApiSetReservationFacilitySpecialsResponse>>;
    public clientApiSetReservationFacilitySpecials(body?: ApiSetReservationFacilitySpecialsRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApiSetReservationFacilitySpecialsResponse>>;
    public clientApiSetReservationFacilitySpecials(body?: ApiSetReservationFacilitySpecialsRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ApiSetReservationFacilitySpecialsResponse>(`${this.basePath}/setReservationFacilitySpecialsv2`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 予約設問
     * setReservationQuestions v2
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public clientApiSetReservationQuestions(body?: ApiSetReservationQuestionsRequest, observe?: 'body', reportProgress?: boolean): Observable<ApiSetReservationQuestionsResponse>;
    public clientApiSetReservationQuestions(body?: ApiSetReservationQuestionsRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApiSetReservationQuestionsResponse>>;
    public clientApiSetReservationQuestions(body?: ApiSetReservationQuestionsRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApiSetReservationQuestionsResponse>>;
    public clientApiSetReservationQuestions(body?: ApiSetReservationQuestionsRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ApiSetReservationQuestionsResponse>(`${this.basePath}/setReservationQuestionsv2`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 予約状況
     * setReservations v2
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public clientApiSetReservations(body?: ApiSetReservationsRequest, observe?: 'body', reportProgress?: boolean): Observable<ApiSetReservationsResponse>;
    public clientApiSetReservations(body?: ApiSetReservationsRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApiSetReservationsResponse>>;
    public clientApiSetReservations(body?: ApiSetReservationsRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApiSetReservationsResponse>>;
    public clientApiSetReservations(body?: ApiSetReservationsRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ApiSetReservationsResponse>(`${this.basePath}/setReservationsv2`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 予約状況予約状態
     * setReservationsStatus v2
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public clientApiSetReservationsStatus(body?: ApiSetReservationsStatusRequest, observe?: 'body', reportProgress?: boolean): Observable<ApiSetReservationsStatusResponse>;
    public clientApiSetReservationsStatus(body?: ApiSetReservationsStatusRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApiSetReservationsStatusResponse>>;
    public clientApiSetReservationsStatus(body?: ApiSetReservationsStatusRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApiSetReservationsStatusResponse>>;
    public clientApiSetReservationsStatus(body?: ApiSetReservationsStatusRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ApiSetReservationsStatusResponse>(`${this.basePath}/setReservationsStatusv2`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 抽選情報
     * setLotteries v2
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public clientApiSetLotteries(body?: ApiSetLotteriesRequest, observe?: 'body', reportProgress?: boolean): Observable<ApiSetLotteriesResponse>;
    public clientApiSetLotteries(body?: ApiSetLotteriesRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApiSetLotteriesResponse>>;
    public clientApiSetLotteries(body?: ApiSetLotteriesRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApiSetLotteriesResponse>>;
    public clientApiSetLotteries(body?: ApiSetLotteriesRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ApiSetLotteriesResponse>(`${this.basePath}/setLotteriesv2`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 予約状況ダウンロード
     * createReservationDownloadFiles v2
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public clientApiCreateReservationDownloadFiles(body?: ApiCreateReservationDownloadFilesRequest, observe?: 'body', reportProgress?: boolean): Observable<ApiCreateReservationDownloadFilesResponse>;
    public clientApiCreateReservationDownloadFiles(body?: ApiCreateReservationDownloadFilesRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApiCreateReservationDownloadFilesResponse>>;
    public clientApiCreateReservationDownloadFiles(body?: ApiCreateReservationDownloadFilesRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApiCreateReservationDownloadFilesResponse>>;
    public clientApiCreateReservationDownloadFiles(body?: ApiCreateReservationDownloadFilesRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ApiCreateReservationDownloadFilesResponse>(`${this.basePath}/createReservationDownloadFilesv2`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

  


    /**
     * 施設属性情報
     * setFacilityAttributes v2
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public clientApiSetFacilityAttributes(body?: ApiSetFacilityAttributesRequest, observe?: 'body', reportProgress?: boolean): Observable<ApiSetFacilityAttributesResponse>;
    public clientApiSetFacilityAttributes(body?: ApiSetFacilityAttributesRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApiSetFacilityAttributesResponse>>;
    public clientApiSetFacilityAttributes(body?: ApiSetFacilityAttributesRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApiSetFacilityAttributesResponse>>;
    public clientApiSetFacilityAttributes(body?: ApiSetFacilityAttributesRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ApiSetFacilityAttributesResponse>(`${this.basePath}/setFacilityAttributesv2`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 展示属性情報
     * setExhibitAttributes v2
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public clientApiSetExhibitAttributes(body?: ApiSetExhibitAttributesRequest, observe?: 'body', reportProgress?: boolean): Observable<ApiSetExhibitAttributesResponse>;
    public clientApiSetExhibitAttributes(body?: ApiSetExhibitAttributesRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApiSetExhibitAttributesResponse>>;
    public clientApiSetExhibitAttributes(body?: ApiSetExhibitAttributesRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApiSetExhibitAttributesResponse>>;
    public clientApiSetExhibitAttributes(body?: ApiSetExhibitAttributesRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ApiSetExhibitAttributesResponse>(`${this.basePath}/setExhibitAttributesv2`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 展示詳細属性情報
     * setExhibitDetailAttributes v2
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public clientApiSetExhibitDetailAttributes(body?: ApiSetExhibitDetailAttributesRequest, observe?: 'body', reportProgress?: boolean): Observable<ApiSetExhibitDetailAttributesResponse>;
    public clientApiSetExhibitDetailAttributes(body?: ApiSetExhibitDetailAttributesRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApiSetExhibitDetailAttributesResponse>>;
    public clientApiSetExhibitDetailAttributes(body?: ApiSetExhibitDetailAttributesRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApiSetExhibitDetailAttributesResponse>>;
    public clientApiSetExhibitDetailAttributes(body?: ApiSetExhibitDetailAttributesRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ApiSetExhibitDetailAttributesResponse>(`${this.basePath}/setExhibitDetailAttributesv2`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 予約施設属性情報
     * setReservationFacilityAttributes v2
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public clientApiSetReservationFacilityAttributes(body?: ApiSetReservationFacilityAttributesRequest, observe?: 'body', reportProgress?: boolean): Observable<ApiSetReservationFacilityAttributesResponse>;
    public clientApiSetReservationFacilityAttributes(body?: ApiSetReservationFacilityAttributesRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApiSetReservationFacilityAttributesResponse>>;
    public clientApiSetReservationFacilityAttributes(body?: ApiSetReservationFacilityAttributesRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApiSetReservationFacilityAttributesResponse>>;
    public clientApiSetReservationFacilityAttributes(body?: ApiSetReservationFacilityAttributesRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ApiSetReservationFacilityAttributesResponse>(`${this.basePath}/setReservationFacilityAttributesv2`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }




    /**
     * 設問情報
     * setQuestions v2
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public clientApiSetQuestions(body?: ApiSetQuestionsRequest, observe?: 'body', reportProgress?: boolean): Observable<ApiSetQuestionsResponse>;
    public clientApiSetQuestions(body?: ApiSetQuestionsRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApiSetQuestionsResponse>>;
    public clientApiSetQuestions(body?: ApiSetQuestionsRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApiSetQuestionsResponse>>;
    public clientApiSetQuestions(body?: ApiSetQuestionsRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ApiSetQuestionsResponse>(`${this.basePath}/setQuestionsv2`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 設問セット
     * setQuestSet v2
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public clientApiSetQuestSet(body?: ApiSetQuestSetRequest, observe?: 'body', reportProgress?: boolean): Observable<ApiSetQuestSetResponse>;
    public clientApiSetQuestSet(body?: ApiSetQuestSetRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApiSetQuestSetResponse>>;
    public clientApiSetQuestSet(body?: ApiSetQuestSetRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApiSetQuestSetResponse>>;
    public clientApiSetQuestSet(body?: ApiSetQuestSetRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ApiSetQuestSetResponse>(`${this.basePath}/setQuestSetv2`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 設問セット
     * createEnqueteDownloadFiles v2
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public clientApiCreateEnqueteDownloadFiles(body?: ApiCreateEnqueteDownloadFilesRequest, observe?: 'body', reportProgress?: boolean): Observable<ApiCreateEnqueteDownloadFilesResponse>;
    public clientApiCreateEnqueteDownloadFiles(body?: ApiCreateEnqueteDownloadFilesRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApiCreateEnqueteDownloadFilesResponse>>;
    public clientApiCreateEnqueteDownloadFiles(body?: ApiCreateEnqueteDownloadFilesRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApiCreateEnqueteDownloadFilesResponse>>;
    public clientApiCreateEnqueteDownloadFiles(body?: ApiCreateEnqueteDownloadFilesRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ApiCreateEnqueteDownloadFilesResponse>(`${this.basePath}/createEnqueteDownloadFilesv2`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }




    /**
     * イベント情報
     * setEntranceExitEvents v2
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public clientApiSetEntranceExitEvents(body?: ApiSetEntranceExitEventsRequest, observe?: 'body', reportProgress?: boolean): Observable<ApiSetEntranceExitEventsResponse>;
    public clientApiSetEntranceExitEvents(body?: ApiSetEntranceExitEventsRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApiSetEntranceExitEventsResponse>>;
    public clientApiSetEntranceExitEvents(body?: ApiSetEntranceExitEventsRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApiSetEntranceExitEventsResponse>>;
    public clientApiSetEntranceExitEvents(body?: ApiSetEntranceExitEventsRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ApiSetEntranceExitEventsResponse>(`${this.basePath}/setEntranceExitEventsv2`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }  

    /**
     * イベント設問
     * setEntranceExitQuestions v2
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public clientApiSetEntranceExitQuestions(body?: ApiSetEntranceExitQuestionsRequest, observe?: 'body', reportProgress?: boolean): Observable<ApiSetEntranceExitQuestionsResponse>;
    public clientApiSetEntranceExitQuestions(body?: ApiSetEntranceExitQuestionsRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApiSetEntranceExitQuestionsResponse>>;
    public clientApiSetEntranceExitQuestions(body?: ApiSetEntranceExitQuestionsRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApiSetEntranceExitQuestionsResponse>>;
    public clientApiSetEntranceExitQuestions(body?: ApiSetEntranceExitQuestionsRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ApiSetEntranceExitQuestionsResponse>(`${this.basePath}/setEntranceExitQuestionsv2`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }    

    /**
     * スタッフ情報
     * setEntranceExitUsers v2
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public clientApiSetEntranceExitUsers(body?: ApiSetEntranceExitUsersRequest, observe?: 'body', reportProgress?: boolean): Observable<ApiSetEntranceExitUsersResponse>;
    public clientApiSetEntranceExitUsers(body?: ApiSetEntranceExitUsersRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApiSetEntranceExitUsersResponse>>;
    public clientApiSetEntranceExitUsers(body?: ApiSetEntranceExitUsersRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApiSetEntranceExitUsersResponse>>;
    public clientApiSetEntranceExitUsers(body?: ApiSetEntranceExitUsersRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ApiSetEntranceExitUsersResponse>(`${this.basePath}/setEntranceExitUsersv2`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }    

    /**
     * エントリー情報
     * setEntranceExitEntries v2
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public clientApiSetEntranceExitEntries(body?: ApiSetEntranceExitEntriesRequest, observe?: 'body', reportProgress?: boolean): Observable<ApiSetEntranceExitEntriesResponse>;
    public clientApiSetEntranceExitEntries(body?: ApiSetEntranceExitEntriesRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApiSetEntranceExitEntriesResponse>>;
    public clientApiSetEntranceExitEntries(body?: ApiSetEntranceExitEntriesRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApiSetEntranceExitEntriesResponse>>;
    public clientApiSetEntranceExitEntries(body?: ApiSetEntranceExitEntriesRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ApiSetEntranceExitEntriesResponse>(`${this.basePath}/setEntranceExitEntriesv2`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }  

    /**
     * 展示来場状況ダウンロード
     * setEntranceExitExhibitTransitDownloadFiles v2
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public clientApiSetEntranceExitExhibitTransitDownloadFiles(body?: ApiSetEntranceExitExhibitTransitDownloadFilesRequest, observe?: 'body', reportProgress?: boolean): Observable<ApiSetEntranceExitExhibitTransitDownloadFilesResponse>;
    public clientApiSetEntranceExitExhibitTransitDownloadFiles(body?: ApiSetEntranceExitExhibitTransitDownloadFilesRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApiSetEntranceExitExhibitTransitDownloadFilesResponse>>;
    public clientApiSetEntranceExitExhibitTransitDownloadFiles(body?: ApiSetEntranceExitExhibitTransitDownloadFilesRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApiSetEntranceExitExhibitTransitDownloadFilesResponse>>;
    public clientApiSetEntranceExitExhibitTransitDownloadFiles(body?: ApiSetEntranceExitExhibitTransitDownloadFilesRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ApiSetEntranceExitExhibitTransitDownloadFilesResponse>(`${this.basePath}/setEntranceExitExhibitTransitDownloadFilesv2`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    } 




    /**
     * 避難所
     * setShelters v2
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public clientApiSetShelters(body?: ApiSetSheltersRequest, observe?: 'body', reportProgress?: boolean): Observable<ApiSetSheltersResponse>;
    public clientApiSetShelters(body?: ApiSetSheltersRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApiSetSheltersResponse>>;
    public clientApiSetShelters(body?: ApiSetSheltersRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApiSetSheltersResponse>>;
    public clientApiSetShelters(body?: ApiSetSheltersRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ApiSetSheltersResponse>(`${this.basePath}/setSheltersv2`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
